import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import { useGetSettingQuery } from '../../../../Redux/Apis/siteApi';

function Testimonial() {
    const {data :{home: {testimonial : {data}}}} = useGetSettingQuery()

    return ( 
        <div className="testimonail-section mt-150 mb-150">
            <div className="container">
                <div className="row">
                    <div className="col-lg-10 offset-lg-1 text-center">
                        <OwlCarousel className="testimonial-sliders owl-carousel" loop autoplay margin={0} autoplayTimeout={4000} items={1} responsive={
                            {
                                0:{items:1, nav:false},
                                600:{items:1,nav:false},
                                1000:{items:1,nav:false,loop:true}
                            }}>
                            {data.lso_comment && data.lso_comment.map((row,index) => 
                                <div className="item" key={index}>
                                    <div className="client-avater">
                                        <img src={row.img_image} alt=""/>
                                    </div>
                                    <div className="client-meta">
                                        <h3>{row.txt_person} <span>{row.txt_career}</span></h3>
                                        <p className="testimonial-body">
                                            " {row.txe_comment} "
                                        </p>
                                        <div className="last-icon">
                                            <i className="fas fa-quote-right"></i>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </OwlCarousel>
                    </div>
                </div>
            </div>
        </div>
     );
}

export default Testimonial;